import { Caption } from '@casavo/base-ui'
import cn from 'classnames'
import React from 'react'

import Label from '@/components/Label'
import { stateDecoration } from '@/design-lib/components/StateDecorator/style.css'

import { countExceeded, counterInner, counterOuter, textArea } from './styles.css'

export interface Props extends Omit<React.HTMLProps<HTMLTextAreaElement>, 'onBlur' | 'onChange'> {
  disabled?: boolean
  error?: string | false
  isPrivate?: boolean
  label: string
  name: string
  onBlur: (event: React.FocusEvent<HTMLTextAreaElement>) => void
  onChange: (s: string) => void
  placeholder?: string
  required?: boolean
  value: string
}

const TextArea: React.FC<Props> = ({
  disabled = false,
  error,
  isPrivate = true,
  label,
  name,
  onBlur,
  onChange,
  placeholder,
  required = false,
  value,
  ...others
}) => {
  const id = `label_${name}`
  const { className, ...othersNoClassName } = others

  const getClass = (): string => {
    if (disabled) return textArea.disabled
    if (error) return textArea.error
    return textArea.default
  }

  return (
    <div>
      <Label htmlFor={id} label={label} required={required} />
      <textarea
        className={cn(getClass(), isPrivate ? 'ca-sensitive' : '', className)}
        id={id}
        name={name}
        placeholder={placeholder}
        required={required}
        value={value}
        onBlur={onBlur}
        onChange={(e) => onChange(e.currentTarget.value)}
        {...othersNoClassName}
      ></textarea>
      {error && (
        <div className={stateDecoration.error}>
          <Caption as="span" data-testid="error">
            {error}
          </Caption>
        </div>
      )}

      <div className={counterOuter}>
        <span className={counterInner}>
          <span className={value.length > 1500 ? countExceeded : ''}>{value.length}</span>
          /1500
        </span>
      </div>
    </div>
  )
}

export default TextArea
